var console = require("../lib/logger.js");
var Url = require("../lib/url.js");
var configModule = require("../define/config.js");

function FrameReadyEventBroker () {

}

FrameReadyEventBroker.name = "FrameReadyEventBroker";

FrameReadyEventBroker.prototype._frameMessageBroker = null;

FrameReadyEventBroker.prototype.setFrameMessageBroker =  function (frameMessageBroker) {

    this._frameMessageBroker = frameMessageBroker;

    return this;
};

FrameReadyEventBroker.prototype.onFrameReady = function (callback, context) {

    if (this._frameMessageBroker == null) {
        return this;
    }

    this._frameMessageBroker.onMessage("FrameReady", function (messageObject, messageProxy) {

        if (context == null) {

            callback(messageProxy, messageObject);

        } else {

            callback.call(context, messageProxy, messageObject);
        }
    });

    return this;
};

FrameReadyEventBroker.prototype.onExtensionFrameReady = function (callback, context) {

    if (this._frameMessageBroker == null) {
        return this;
    }

    var me = this;

    this._frameMessageBroker.onMessage("ExtensionFrameReady", function (messageObject, messageProxy) {

        if (messageObject.senderId === "Message.ExtensionFrame") {

            var isSameOrigin = false;

            if (messageObject.messageOrigin != null) {

                isSameOrigin = (
                    configModule.EXTENSIONFRAME_BASEURL.toLowerCase() ===
                    messageObject.messageOrigin.toLowerCase()
                );
            }

            if (isSameOrigin === false) {

                console.warn(__GLOBAL_LOG_PREFIX__, "[" + me.constructor.name + "][onExtensionFrameReady] Not from Extension Frame origin");
                return;
            }

            if (context == null) {

                callback(messageObject, messageProxy);

            } else {

                callback.call(context, messageObject, messageProxy);
            }
        }
    });

    return this;
};

FrameReadyEventBroker.prototype.onTopBarReady = function (callback, context) {

    if (this._frameMessageBroker == null) {
        return this;
    }

    var me = this;

    this._frameMessageBroker.onMessage("TopBarReady", function (messageObject, messageProxy) {

        if (messageObject.senderId === "Message.TopBar") {

            var isSameOrigin = false;

            if (messageObject.messageOrigin != null) {

                isSameOrigin = (
                    configModule.EXTENSIONFRAME_BASEURL.toLowerCase() ===
                    messageObject.messageOrigin.toLowerCase()
                );
            }

            if (isSameOrigin === false) {

                console.warn(__GLOBAL_LOG_PREFIX__, "[" + me.constructor.name + "][onTopBarReady] Not from Top Bar origin");
                return;
            }

            if (context == null) {

                callback(messageProxy, messageObject);

            } else {

                callback.call(context, messageProxy, messageObject);
            }
        }
    });

    return this;
};

FrameReadyEventBroker.prototype.onExtensionReady = function (callback, context) {

    if (this._frameMessageBroker == null) {
        return this;
    }

    this._frameMessageBroker.onMessage("ExtensionReady", function (messageObject, messageProxy) {

        if (messageObject.senderId === "Message.Extension") {

            if (context == null) {

                callback(messageProxy, messageObject);

            } else {

                callback.call(context, messageProxy, messageObject);
            }
        }
    });

    return this;
};

module.exports = FrameReadyEventBroker;